<template>
    <div class="px-7.5 flex flex-wrap gap-y-4 justify-center mt-10">
        <button
            v-for="(item, index) in list"
            :key="index"
            class="px-3 h-11 w-full flex items-center gap-x-2 bg-white-300 dark:bg-blue-870 border border-gray-100 dark:border-blue-760 rounded-2.5"
            @click="selectItem(item.text)"
        >
            <component :is="getIcon(item.icon)"/>

            <span class="text-xxs text-gray-370 dark:text-white-700">
                {{ item.title }}
            </span>
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue'

import CampaignListIcon from '@/components/ai/icons/CampaignListIcon.vue'
import ConnectListIcon from '@/components/ai/icons/ConnectListIcon.vue'
import ConvertedListIcon from '@/components/ai/icons/ConvertedListIcon.vue'
import SettingsListIcon from '@/components/ai/icons/SettingsListIcon.vue'

import { AGENTS } from '@/constants/aiAgents'

const props = defineProps({
    currentAgentType: {
        type: String,
        default: AGENTS.diagnostic.type,
    },
})

const emits = defineEmits(['selectPreset'])

const icons = {
    campaign: 'campaign',
    connect: 'connect',
    converted: 'converted',
    settings: 'settings',
}

const list = computed(() => (props.currentAgentType === AGENTS.diagnostic.type
    ? [
        { title: 'Can you check my campaign setup?', text: 'Can you check my campaign setup? \nCampaign name: ', icon: icons.campaign },
        { title: 'Why didn\'t my call connect?', text: 'Why didn\'t my call connect? \nCall UUID: ', icon: icons.connect },
        { title: 'Why wasn\'t this call converted?', text: 'Why wasn\'t this call converted? \nCall UUID: ', icon: icons.converted },
    ] : [
        { title: 'Create campaign', text: 'Create campaign \nName: \nCountry: ', icon: icons.campaign },
        { title: 'Create destination', text: 'Create destination \nName: \nDestination: \nType: ', icon: icons.connect },
        { title: 'Create number pool', text: 'Create number pool \nName: ', icon: icons.converted },
        { title: 'Create traffic source', text: 'Create traffic source \nName: ', icon: icons.settings },
    ]))

function getIcon(iconName) {
    switch (iconName) {
    case icons.campaign:
        return CampaignListIcon
    case icons.connect:
        return ConnectListIcon
    case icons.converted:
        return ConvertedListIcon
    case icons.settings:
        return SettingsListIcon
    }
}

function selectItem(text) {
    emits('selectPreset', text)
}
</script>
